import { compareAsc, eachDayOfInterval, isAfter, isSameDay } from 'date-fns';
import type { SettingsSpecialInterval } from '../settings-special-interval/settings-special-interval';
import { getWorkHoursIntervalsForDate } from '../work-hours-interval/get-work-hours-intervals-for-date';
import type { SpecialDay } from './special-day';

export function getSpecialDaysFromDate(
  settingsSpecialIntervals: SettingsSpecialInterval[],
  givenDate: Date = new Date()
) {
  return settingsSpecialIntervals
    .filter(
      ({ dates: [, endDate] }) =>
        isSameDay(endDate, givenDate) || isAfter(endDate, givenDate)
    )
    .flatMap((day) => {
      const [startDate, endDate] = day.dates;

      if (isSameDay(startDate, endDate)) {
        return formatSpecialDay(day, startDate, givenDate);
      }

      return eachDayOfInterval({ start: startDate, end: endDate }).map(
        (_, index) => {
          const date = new Date(startDate);
          date.setDate(date.getDate() + index);

          return formatSpecialDay(day, date, givenDate);
        }
      );
    })
    .sort((a, b) => compareAsc(a.date, b.date));
}

const formatSpecialDay = (
  day: SettingsSpecialInterval,
  date: Date,
  givenDate = new Date()
): SpecialDay => ({
  date,
  hours: getWorkHoursIntervalsForDate(day.settingsHours, date, true),
  isClosed: day.isClosed,
  isToday: isSameDay(givenDate, date)
});
